import { copyPropertiesFrom } from "@/util/reflection";

export default class RoleModel {
    roleID = 0;
    roleName = "";

    constructor(roleData: any) {
       copyPropertiesFrom(this, roleData);
    }
}